/* Storefront glue for existing Shopify accounts, localization and Beast UI. No customer PII. */
(() => {
  const node = document.getElementById('sae-customer-config');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  window.saeCustomerMessages = config.messages;
  const prefKey = 'saeShoppingPreferencesV1';
  const market = document.querySelector('.sae-market-dialog');
  const form = market?.querySelector('form');
  const country = form?.querySelector('[name="country_code"]');
  const language = form?.querySelector('[name="locale_code"]');
  const remember = form?.querySelector('[data-sae-remember]');
  const status = form?.querySelector('[data-sae-pref-status]');
  let displayCurrency = config.currency;
  let pendingCurrency = null;
  let userChoseCurrency = false;
  let observer;
  const convert = code => {
    if(!['USD','EGP','SAR'].includes(code))return;
    const button=[...document.querySelectorAll('.currency-switcher-btn[doubly-currency]')].find(b=>b.getAttribute('doubly-currency')===code);
    if(button&&!button.classList.contains('selected'))button.click();
  };
  const updateCurrencyStatus = () => {
    const selected = document.querySelector('.currency-switcher-btn.selected[doubly-currency]');
    displayCurrency=selected?.getAttribute('doubly-currency') || config.currency;
    const message=displayCurrency===config.currency ? config.messages.actual_status : config.messages.estimated_status.replace('{{ currency }}',displayCurrency);
    document.querySelectorAll('[data-sae-currency-status]').forEach(el=>{if(el.textContent!==message)el.textContent=message;});
    document.querySelectorAll('.currency-switcher-btn[doubly-currency]').forEach(b=>{
      b.type='button';b.setAttribute('aria-pressed',String(b.classList.contains('selected')));
    });
  };
  let pendingAttempts=0;
  const applyPendingCurrency=()=>{
    if(!pendingCurrency)return;
    const selected=document.querySelector('.currency-switcher-btn.selected[doubly-currency]');
    if(selected?.getAttribute('doubly-currency')===pendingCurrency){pendingCurrency=null;return;}
    convert(pendingCurrency);
    if(++pendingAttempts<60)setTimeout(applyPendingCurrency,100);else pendingCurrency=null;
  };
  const decorateCurrencyButtons = () => {
    const field=market?.querySelector('[data-sae-beast-field]');
    if(!field)return;
    field.querySelectorAll('.currency-switcher-btn[doubly-currency]').forEach(button=>{
      const code=button.getAttribute('doubly-currency')?.toLowerCase();
      if(!['usd','egp','sar'].includes(code))return;
      const name=field.getAttribute('data-sae-currency-name-'+code);
      if(!name||button.querySelector('.sae-currency-option-name'))return;
      const label=document.createElement('span');
      label.className='sae-currency-option-name';
      label.dir='auto';
      label.textContent=name;
      button.appendChild(label);
    });
  };
  const mountBeast = () => {
    const wrapper=document.querySelector('.doubly-float');
    const slot=market?.querySelector('[data-sae-beast-slot]');
    if(!wrapper||!slot||!wrapper.querySelector('.currency-switcher-btn'))return false;
    if(wrapper.parentElement!==slot)slot.append(wrapper);
    market.querySelector('[data-sae-beast-field]').hidden=false;
    decorateCurrencyButtons();
    wrapper.addEventListener('click',e=>{if(e.target.closest('.currency-switcher-btn')){if(e.isTrusted){userChoseCurrency=true;pendingCurrency=null;}queueMicrotask(updateCurrencyStatus);}});
    new MutationObserver(()=>{decorateCurrencyButtons();updateCurrencyStatus();}).observe(wrapper,{attributes:true,childList:true,subtree:true,attributeFilter:['class']});
    if(pendingCurrency)setTimeout(applyPendingCurrency,100);
    updateCurrencyStatus();return true;
  };
  try {pendingCurrency=sessionStorage.getItem('saeCurrencyNext');sessionStorage.removeItem('saeCurrencyNext');}catch{}
  if(!mountBeast()){
    observer=new MutationObserver(()=>{if(mountBeast())observer.disconnect();});
    observer.observe(document.body,{childList:true,subtree:true});
    setTimeout(()=>observer.disconnect(),15000);
  }
  if(form&&country){
    country.addEventListener('change',()=>{
      userChoseCurrency=false;
      const flag=country.value==='EG'?'🇪🇬':country.value==='SA'?'🇸🇦':country.value;
      const preview=market.querySelector('[data-sae-country-preview]');
      if(preview)preview.textContent=flag+' '+country.selectedOptions[0].textContent;
    });
    form.addEventListener('submit',()=>{
      const changedCountry=country.value!==config.country;
      const currency=changedCountry&&!userChoseCurrency ? ({EG:'EGP',SA:'SAR'}[country.value]||config.currency) : displayCurrency;
      try {sessionStorage.setItem('saeCurrencyNext',currency);}catch{}
      if(remember?.checked){
        try {localStorage.setItem(prefKey,JSON.stringify({version:1,language:language?.value||config.language,shoppingCountry:country.value,displayCurrency:currency}));}
        catch {if(status)status.textContent=config.messages.pref_error;}
      }
    });
  }
  document.addEventListener('click',e=>{
    document.querySelectorAll('.sae-account-menu[open]').forEach(menu=>{if(!menu.contains(e.target))menu.open=false;});
  });
  document.addEventListener('keydown',e=>{
    if(e.key==='Escape')document.querySelectorAll('.sae-account-menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});
  });
})();
